import { fetchData, apiURL } from "../api-helper";

const getAnomalyEvents = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/anomalies`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default { getAnomalyEvents };
